var _g, _path, _path2, _path3, _g2, _g3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _g4, _g5, _path13, _g6, _g7, _path14, _path15, _path16, _g8, _g9, _path17, _path18, _g10, _g11, _g12, _g13, _g14, _g15, _path19, _path20, _g16, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _g17, _g18, _g19, _path28, _g20, _g21, _g22, _g23, _g24, _path29, _path30, _path31, _g25, _g26, _path32, _path33, _path34, _g27, _g28, _path35, _path36, _path37, _path38, _path39, _path40, _g29, _g30, _g31, _g32, _g33, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTeacher(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_4002_1667)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.3742 25.0015H2.62415C2.28415 25.0015 2.00415 24.7215 2.00415 24.3815V4.63147C2.00415 4.29147 2.28415 4.01147 2.62415 4.01147H29.3642C29.7142 4.01147 29.9841 4.29147 29.9841 4.63147V24.3715C29.9941 24.7215 29.7142 25.0015 29.3742 25.0015Z",
    fill: "url(#paint0_linear_4002_1667)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.00415 24.0015V5.01147H28.9942V24.0015H3.00415Z",
    fill: "url(#paint1_linear_4002_1667)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.00415 24.0015V5.01147H28.9942V24.0015H3.00415Z",
    fill: "url(#paint2_radial_4002_1667)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.00415 24.0015V5.01147H28.9942V24.0015H3.00415Z",
    fill: "url(#paint3_radial_4002_1667)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_4002_1667)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.21875 4.40479H29.4312C29.4865 4.40479 29.5312 4.44956 29.5312 4.50479V24.0896",
    stroke: "url(#paint4_linear_4002_1667)",
    strokeWidth: 0.3,
    strokeLinecap: "round"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_i_4002_1667)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.9942 24.0015H3.00415V5.01154L2.08415 4.33154C2.03415 4.42154 2.00415 4.53154 2.00415 4.63154V24.3715C2.00415 24.7215 2.28415 24.9915 2.62415 24.9915H29.3642C29.6042 24.9915 29.8042 24.8615 29.9142 24.6615L28.9942 24.0015Z",
    fill: "url(#paint5_linear_4002_1667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9942 24.0015H3.00415V5.01154L2.08415 4.33154C2.03415 4.42154 2.00415 4.53154 2.00415 4.63154V24.3715C2.00415 24.7215 2.28415 24.9915 2.62415 24.9915H29.3642C29.6042 24.9915 29.8042 24.8615 29.9142 24.6615L28.9942 24.0015Z",
    fill: "url(#paint6_linear_4002_1667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9942 24.0015H3.00415V5.01154L2.08415 4.33154C2.03415 4.42154 2.00415 4.53154 2.00415 4.63154V24.3715C2.00415 24.7215 2.28415 24.9915 2.62415 24.9915H29.3642C29.6042 24.9915 29.8042 24.8615 29.9142 24.6615L28.9942 24.0015Z",
    fill: "url(#paint7_radial_4002_1667)"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0042 15.5115C9.93415 15.5115 5.00415 20.4315 5.00415 26.5115V30.0115C7.48002 30.0115 25 30.0115 26.9942 30.0115V26.5115C26.9942 20.4315 22.0742 15.5115 16.0042 15.5115Z",
    fill: "url(#paint8_radial_4002_1667)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0042 15.5115C9.93415 15.5115 5.00415 20.4315 5.00415 26.5115V30.0115C7.48002 30.0115 25 30.0115 26.9942 30.0115V26.5115C26.9942 20.4315 22.0742 15.5115 16.0042 15.5115Z",
    fill: "url(#paint9_radial_4002_1667)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0042 15.5115C9.93415 15.5115 5.00415 20.4315 5.00415 26.5115V30.0115C7.48002 30.0115 25 30.0115 26.9942 30.0115V26.5115C26.9942 20.4315 22.0742 15.5115 16.0042 15.5115Z",
    fill: "url(#paint10_radial_4002_1667)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6742 30.0116V17.7668C25.3004 19.776 26.9942 22.9441 26.9942 26.5116V30.0116H22.6742Z",
    fill: "url(#paint11_radial_4002_1667)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6742 30.0116V17.7668C25.3004 19.776 26.9942 22.9441 26.9942 26.5116V30.0116H22.6742Z",
    fill: "url(#paint12_linear_4002_1667)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6742 30.0116V17.7668C25.3004 19.776 26.9942 22.9441 26.9942 26.5116V30.0116H22.6742Z",
    fill: "url(#paint13_linear_4002_1667)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M9.29419 30.0116V17.7668C6.66803 19.776 4.97418 22.9441 4.97418 26.5116V30.0116H9.29419Z",
    fill: "url(#paint14_linear_4002_1667)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M9.29419 30.0116V17.7668C6.66803 19.776 4.97418 22.9441 4.97418 26.5116V30.0116H9.29419Z",
    fill: "url(#paint15_radial_4002_1667)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0541 16.8315H13.9441V30.0115H18.0541V16.8315Z",
    fill: "url(#paint16_radial_4002_1667)"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_i_4002_1667)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.3442 16.0715L20.7042 19C20.7942 19.19 20.6542 19.41 20.4442 19.41L19.4805 19.1445C19.0587 19.039 19.0442 19.4212 19.2042 19.5812L20.5642 21.1415C20.8242 21.4015 20.9242 21.7915 20.7942 22.1415L18.0542 30.0115V16.0715H19.3442Z",
    fill: "url(#paint17_linear_4002_1667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3442 16.0715L20.7042 19C20.7942 19.19 20.6542 19.41 20.4442 19.41L19.4805 19.1445C19.0587 19.039 19.0442 19.4212 19.2042 19.5812L20.5642 21.1415C20.8242 21.4015 20.9242 21.7915 20.7942 22.1415L18.0542 30.0115V16.0715H19.3442Z",
    fill: "url(#paint18_radial_4002_1667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3442 16.0715L20.7042 19C20.7942 19.19 20.6542 19.41 20.4442 19.41L19.4805 19.1445C19.0587 19.039 19.0442 19.4212 19.2042 19.5812L20.5642 21.1415C20.8242 21.4015 20.9242 21.7915 20.7942 22.1415L18.0542 30.0115V16.0715H19.3442Z",
    fill: "url(#paint19_radial_4002_1667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3442 16.0715L20.7042 19C20.7942 19.19 20.6542 19.41 20.4442 19.41L19.4805 19.1445C19.0587 19.039 19.0442 19.4212 19.2042 19.5812L20.5642 21.1415C20.8242 21.4015 20.9242 21.7915 20.7942 22.1415L18.0542 30.0115V16.0715H19.3442Z",
    fill: "url(#paint20_radial_4002_1667)"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_i_4002_1667)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.6541 16.0715L11.2941 19C11.2041 19.19 11.3441 19.41 11.5541 19.41L12.5178 19.1445C12.9396 19.039 12.9541 19.4212 12.7941 19.5812L11.4341 21.1415C11.1741 21.4015 11.0741 21.7915 11.2041 22.1415L13.9441 30.0115V16.0715H12.6541Z",
    fill: "url(#paint21_linear_4002_1667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6541 16.0715L11.2941 19C11.2041 19.19 11.3441 19.41 11.5541 19.41L12.5178 19.1445C12.9396 19.039 12.9541 19.4212 12.7941 19.5812L11.4341 21.1415C11.1741 21.4015 11.0741 21.7915 11.2041 22.1415L13.9441 30.0115V16.0715H12.6541Z",
    fill: "url(#paint22_radial_4002_1667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6541 16.0715L11.2941 19C11.2041 19.19 11.3441 19.41 11.5541 19.41L12.5178 19.1445C12.9396 19.039 12.9541 19.4212 12.7941 19.5812L11.4341 21.1415C11.1741 21.4015 11.0741 21.7915 11.2041 22.1415L13.9441 30.0115V16.0715H12.6541Z",
    fill: "url(#paint23_linear_4002_1667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6541 16.0715L11.2941 19C11.2041 19.19 11.3441 19.41 11.5541 19.41L12.5178 19.1445C12.9396 19.039 12.9541 19.4212 12.7941 19.5812L11.4341 21.1415C11.1741 21.4015 11.0741 21.7915 11.2041 22.1415L13.9441 30.0115V16.0715H12.6541Z",
    fill: "url(#paint24_radial_4002_1667)"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0041 18.6815C14.8641 18.6815 13.9441 17.7615 13.9441 16.6215V14.0615C13.9441 12.9215 14.8641 12.0015 16.0041 12.0015C17.1441 12.0015 18.0641 12.9215 18.0641 14.0615V16.6215C18.0541 17.7615 17.1341 18.6815 16.0041 18.6815Z",
    fill: "url(#paint25_radial_4002_1667)"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_i_4002_1667)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.0475 23.1194C22.5975 23.1194 23.0475 23.5694 23.0475 24.1194V26.4094H21.0475V24.1194C21.0475 23.5694 21.4875 23.1194 22.0475 23.1194Z",
    fill: "url(#paint26_radial_4002_1667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.0475 23.1194C22.5975 23.1194 23.0475 23.5694 23.0475 24.1194V26.4094H21.0475V24.1194C21.0475 23.5694 21.4875 23.1194 22.0475 23.1194Z",
    fill: "url(#paint27_radial_4002_1667)"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_i_4002_1667)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.95068 23.1116C9.40068 23.1116 8.95068 23.5616 8.95068 24.1116V26.4016H10.9507V24.1116C10.9507 23.5616 10.5107 23.1116 9.95068 23.1116Z",
    fill: "url(#paint28_radial_4002_1667)"
  }))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3141 21.8916V30.0116H21.6541V20.8216C21.6541 20.3716 21.2941 20.0116 20.8441 20.0116H12.2041C11.1541 20.0016 10.3141 20.8516 10.3141 21.8916Z",
    fill: "url(#paint29_linear_4002_1667)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.408 30.0115V21.6052H10.3141V30.0115H12.408Z",
    fill: "#513358"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.408 30.0115V21.6052H10.3141V30.0115H12.408Z",
    fill: "url(#paint30_linear_4002_1667)"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_i_4002_1667)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.3436 25.3807C13.3525 25.6579 13.228 25.9043 13.0413 26.0481C13.2191 26.1816 13.3436 26.4177 13.3436 26.6847C13.3436 26.9517 13.228 27.1878 13.0413 27.3213C13.2191 27.4548 13.3436 27.6909 13.3436 27.9579C13.3436 28.2249 13.228 28.461 13.0413 28.5945C13.228 28.7383 13.3436 28.9847 13.3436 29.2619C13.3347 29.6829 13.0235 30.0115 12.6589 30.0115H9.72434C9.29749 30.0115 8.95068 29.611 8.95068 29.1182V25.5142C8.95068 25.0213 9.29749 24.6208 9.72434 24.6208H12.5664C13.0413 24.6208 13.3358 25.0113 13.3436 25.3807Z",
    fill: "url(#paint31_linear_4002_1667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3436 25.3807C13.3525 25.6579 13.228 25.9043 13.0413 26.0481C13.2191 26.1816 13.3436 26.4177 13.3436 26.6847C13.3436 26.9517 13.228 27.1878 13.0413 27.3213C13.2191 27.4548 13.3436 27.6909 13.3436 27.9579C13.3436 28.2249 13.228 28.461 13.0413 28.5945C13.228 28.7383 13.3436 28.9847 13.3436 29.2619C13.3347 29.6829 13.0235 30.0115 12.6589 30.0115H9.72434C9.29749 30.0115 8.95068 29.611 8.95068 29.1182V25.5142C8.95068 25.0213 9.29749 24.6208 9.72434 24.6208H12.5664C13.0413 24.6208 13.3358 25.0113 13.3436 25.3807Z",
    fill: "url(#paint32_radial_4002_1667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3436 25.3807C13.3525 25.6579 13.228 25.9043 13.0413 26.0481C13.2191 26.1816 13.3436 26.4177 13.3436 26.6847C13.3436 26.9517 13.228 27.1878 13.0413 27.3213C13.2191 27.4548 13.3436 27.6909 13.3436 27.9579C13.3436 28.2249 13.228 28.461 13.0413 28.5945C13.228 28.7383 13.3436 28.9847 13.3436 29.2619C13.3347 29.6829 13.0235 30.0115 12.6589 30.0115H9.72434C9.29749 30.0115 8.95068 29.611 8.95068 29.1182V25.5142C8.95068 25.0213 9.29749 24.6208 9.72434 24.6208H12.5664C13.0413 24.6208 13.3358 25.0113 13.3436 25.3807Z",
    fill: "url(#paint33_radial_4002_1667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3436 25.3807C13.3525 25.6579 13.228 25.9043 13.0413 26.0481C13.2191 26.1816 13.3436 26.4177 13.3436 26.6847C13.3436 26.9517 13.228 27.1878 13.0413 27.3213C13.2191 27.4548 13.3436 27.6909 13.3436 27.9579C13.3436 28.2249 13.228 28.461 13.0413 28.5945C13.228 28.7383 13.3436 28.9847 13.3436 29.2619C13.3347 29.6829 13.0235 30.0115 12.6589 30.0115H9.72434C9.29749 30.0115 8.95068 29.611 8.95068 29.1182V25.5142C8.95068 25.0213 9.29749 24.6208 9.72434 24.6208H12.5664C13.0413 24.6208 13.3358 25.0113 13.3436 25.3807Z",
    fill: "url(#paint34_radial_4002_1667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3436 25.3807C13.3525 25.6579 13.228 25.9043 13.0413 26.0481C13.2191 26.1816 13.3436 26.4177 13.3436 26.6847C13.3436 26.9517 13.228 27.1878 13.0413 27.3213C13.2191 27.4548 13.3436 27.6909 13.3436 27.9579C13.3436 28.2249 13.228 28.461 13.0413 28.5945C13.228 28.7383 13.3436 28.9847 13.3436 29.2619C13.3347 29.6829 13.0235 30.0115 12.6589 30.0115H9.72434C9.29749 30.0115 8.95068 29.611 8.95068 29.1182V25.5142C8.95068 25.0213 9.29749 24.6208 9.72434 24.6208H12.5664C13.0413 24.6208 13.3358 25.0113 13.3436 25.3807Z",
    fill: "url(#paint35_radial_4002_1667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3436 25.3807C13.3525 25.6579 13.228 25.9043 13.0413 26.0481C13.2191 26.1816 13.3436 26.4177 13.3436 26.6847C13.3436 26.9517 13.228 27.1878 13.0413 27.3213C13.2191 27.4548 13.3436 27.6909 13.3436 27.9579C13.3436 28.2249 13.228 28.461 13.0413 28.5945C13.228 28.7383 13.3436 28.9847 13.3436 29.2619C13.3347 29.6829 13.0235 30.0115 12.6589 30.0115H9.72434C9.29749 30.0115 8.95068 29.611 8.95068 29.1182V25.5142C8.95068 25.0213 9.29749 24.6208 9.72434 24.6208H12.5664C13.0413 24.6208 13.3358 25.0113 13.3436 25.3807Z",
    fill: "url(#paint36_linear_4002_1667)"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_ii_4002_1667)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.6547 25.3807C18.6458 25.6579 18.7703 25.9043 18.957 26.0481C18.7792 26.1816 18.6547 26.4177 18.6547 26.6847C18.6547 26.9517 18.7703 27.1878 18.957 27.3213C18.7792 27.4548 18.6547 27.6909 18.6547 27.9579C18.6547 28.2249 18.7703 28.461 18.957 28.5945C18.7703 28.7383 18.6547 28.9847 18.6547 29.2619C18.6636 29.6829 18.9748 30.0115 19.3394 30.0115H22.274C22.7008 30.0115 23.0476 29.611 23.0476 29.1182V25.5142C23.0476 25.0213 22.7008 24.6208 22.274 24.6208H19.4319C18.957 24.6208 18.6625 25.0113 18.6547 25.3807Z",
    fill: "url(#paint37_linear_4002_1667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6547 25.3807C18.6458 25.6579 18.7703 25.9043 18.957 26.0481C18.7792 26.1816 18.6547 26.4177 18.6547 26.6847C18.6547 26.9517 18.7703 27.1878 18.957 27.3213C18.7792 27.4548 18.6547 27.6909 18.6547 27.9579C18.6547 28.2249 18.7703 28.461 18.957 28.5945C18.7703 28.7383 18.6547 28.9847 18.6547 29.2619C18.6636 29.6829 18.9748 30.0115 19.3394 30.0115H22.274C22.7008 30.0115 23.0476 29.611 23.0476 29.1182V25.5142C23.0476 25.0213 22.7008 24.6208 22.274 24.6208H19.4319C18.957 24.6208 18.6625 25.0113 18.6547 25.3807Z",
    fill: "url(#paint38_radial_4002_1667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6547 25.3807C18.6458 25.6579 18.7703 25.9043 18.957 26.0481C18.7792 26.1816 18.6547 26.4177 18.6547 26.6847C18.6547 26.9517 18.7703 27.1878 18.957 27.3213C18.7792 27.4548 18.6547 27.6909 18.6547 27.9579C18.6547 28.2249 18.7703 28.461 18.957 28.5945C18.7703 28.7383 18.6547 28.9847 18.6547 29.2619C18.6636 29.6829 18.9748 30.0115 19.3394 30.0115H22.274C22.7008 30.0115 23.0476 29.611 23.0476 29.1182V25.5142C23.0476 25.0213 22.7008 24.6208 22.274 24.6208H19.4319C18.957 24.6208 18.6625 25.0113 18.6547 25.3807Z",
    fill: "url(#paint39_radial_4002_1667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6547 25.3807C18.6458 25.6579 18.7703 25.9043 18.957 26.0481C18.7792 26.1816 18.6547 26.4177 18.6547 26.6847C18.6547 26.9517 18.7703 27.1878 18.957 27.3213C18.7792 27.4548 18.6547 27.6909 18.6547 27.9579C18.6547 28.2249 18.7703 28.461 18.957 28.5945C18.7703 28.7383 18.6547 28.9847 18.6547 29.2619C18.6636 29.6829 18.9748 30.0115 19.3394 30.0115H22.274C22.7008 30.0115 23.0476 29.611 23.0476 29.1182V25.5142C23.0476 25.0213 22.7008 24.6208 22.274 24.6208H19.4319C18.957 24.6208 18.6625 25.0113 18.6547 25.3807Z",
    fill: "url(#paint40_radial_4002_1667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6547 25.3807C18.6458 25.6579 18.7703 25.9043 18.957 26.0481C18.7792 26.1816 18.6547 26.4177 18.6547 26.6847C18.6547 26.9517 18.7703 27.1878 18.957 27.3213C18.7792 27.4548 18.6547 27.6909 18.6547 27.9579C18.6547 28.2249 18.7703 28.461 18.957 28.5945C18.7703 28.7383 18.6547 28.9847 18.6547 29.2619C18.6636 29.6829 18.9748 30.0115 19.3394 30.0115H22.274C22.7008 30.0115 23.0476 29.611 23.0476 29.1182V25.5142C23.0476 25.0213 22.7008 24.6208 22.274 24.6208H19.4319C18.957 24.6208 18.6625 25.0113 18.6547 25.3807Z",
    fill: "url(#paint41_radial_4002_1667)"
  }))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6541 22.9959V20.7102C21.6541 20.3221 21.2941 20.0115 20.8441 20.0115H12.2041C12.1982 20.0115 12.1922 20.0115 12.1863 20.0115H12.1852C11.144 20.0117 10.3141 20.7415 10.3141 21.6331V21.6331C10.3141 22.3858 10.9243 22.9959 11.6769 22.9959H21.6541Z",
    fill: "url(#paint42_linear_4002_1667)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1473 21.5037C11.1473 21.1197 11.4586 20.8083 11.8427 20.8083H21.6541V22.199H11.8427C11.4586 22.199 11.1473 21.8877 11.1473 21.5037Z",
    fill: "url(#paint43_linear_4002_1667)"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter9_f_4002_1667)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.0234 26.0505H20.9453",
    stroke: "url(#paint44_linear_4002_1667)",
    strokeWidth: 0.1,
    strokeLinecap: "round"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter10_f_4002_1667)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.9324 26.0505H11.0105",
    stroke: "url(#paint45_linear_4002_1667)",
    strokeWidth: 0.1,
    strokeLinecap: "round"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter11_f_4002_1667)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.0234 27.3162H20.9453",
    stroke: "url(#paint46_linear_4002_1667)",
    strokeWidth: 0.1,
    strokeLinecap: "round"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter12_f_4002_1667)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.9324 27.3162H11.0105",
    stroke: "url(#paint47_linear_4002_1667)",
    strokeWidth: 0.1,
    strokeLinecap: "round"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter13_f_4002_1667)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.0234 28.5818H20.9453",
    stroke: "url(#paint48_linear_4002_1667)",
    strokeWidth: 0.1,
    strokeLinecap: "round"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter14_f_4002_1667)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.9324 28.5818H11.0105",
    stroke: "url(#paint49_linear_4002_1667)",
    strokeWidth: 0.1,
    strokeLinecap: "round"
  }))), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8454 12.2236C21.1806 12.2127 21.4946 12.0991 21.75 11.915V12.846C21.75 13.7392 21.2179 14.5348 20.4091 14.865C20.5794 14.5024 20.6964 14.1072 20.755 13.685L20.8454 12.2236Z",
    fill: "url(#paint50_radial_4002_1667)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1228 12.2236C10.7876 12.2127 10.4737 12.0991 10.2183 11.915V12.846C10.2183 13.7392 10.7504 14.5348 11.5592 14.865C11.3889 14.5024 11.2718 14.1072 11.2133 13.685L11.1228 12.2236Z",
    fill: "url(#paint51_radial_4002_1667)"
  })), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter15_ii_4002_1667)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.1594 13.7388C11.4167 15.6911 13.0782 17.1446 15.0451 17.1446H16.9317C18.8987 17.1446 20.5601 15.6911 20.8174 13.7388C20.9354 11.8551 21.054 9.97893 21.1415 8.09624C21.1309 7.32924 20.5263 6.69633 19.7625 6.66415H18.3623C17.4077 6.66415 16.5431 6.10097 16.1507 5.22134C16.0499 4.96925 15.8059 4.80298 15.5354 4.80298H14.2625C12.4168 4.80298 10.9211 6.31551 10.9211 8.18205C10.9211 10.0428 11.0374 11.8734 11.1594 13.7388Z",
    fill: "url(#paint52_radial_4002_1667)"
  }))), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1594 13.7388C11.4167 15.6911 13.0782 17.1446 15.0451 17.1446H16.9317C18.8987 17.1446 20.5601 15.6911 20.8174 13.7388C20.9354 11.8551 21.054 9.97893 21.1415 8.09624C21.1309 7.32924 20.5263 6.69633 19.7625 6.66415H18.3623C17.4077 6.66415 16.5431 6.10097 16.1507 5.22134C16.0499 4.96925 15.8059 4.80298 15.5354 4.80298H14.2625C12.4168 4.80298 10.9211 6.31551 10.9211 8.18205C10.9211 10.0428 11.0374 11.8734 11.1594 13.7388Z",
    fill: "url(#paint53_linear_4002_1667)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1594 13.7388C11.4167 15.6911 13.0782 17.1446 15.0451 17.1446H16.9317C18.8987 17.1446 20.5601 15.6911 20.8174 13.7388C20.9354 11.8551 21.054 9.97893 21.1415 8.09624C21.1309 7.32924 20.5263 6.69633 19.7625 6.66415H18.3623C17.4077 6.66415 16.5431 6.10097 16.1507 5.22134C16.0499 4.96925 15.8059 4.80298 15.5354 4.80298H14.2625C12.4168 4.80298 10.9211 6.31551 10.9211 8.18205C10.9211 10.0428 11.0374 11.8734 11.1594 13.7388Z",
    fill: "url(#paint54_radial_4002_1667)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1594 13.7388C11.4167 15.6911 13.0782 17.1446 15.0451 17.1446H16.9317C18.8987 17.1446 20.5601 15.6911 20.8174 13.7388C20.9354 11.8551 21.054 9.97893 21.1415 8.09624C21.1309 7.32924 20.5263 6.69633 19.7625 6.66415H18.3623C17.4077 6.66415 16.5431 6.10097 16.1507 5.22134C16.0499 4.96925 15.8059 4.80298 15.5354 4.80298H14.2625C12.4168 4.80298 10.9211 6.31551 10.9211 8.18205C10.9211 10.0428 11.0374 11.8734 11.1594 13.7388Z",
    fill: "url(#paint55_radial_4002_1667)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1594 13.7388C11.4167 15.6911 13.0782 17.1446 15.0451 17.1446H16.9317C18.8987 17.1446 20.5601 15.6911 20.8174 13.7388C20.9354 11.8551 21.054 9.97893 21.1415 8.09624C21.1309 7.32924 20.5263 6.69633 19.7625 6.66415H18.3623C17.4077 6.66415 16.5431 6.10097 16.1507 5.22134C16.0499 4.96925 15.8059 4.80298 15.5354 4.80298H14.2625C12.4168 4.80298 10.9211 6.31551 10.9211 8.18205C10.9211 10.0428 11.0374 11.8734 11.1594 13.7388Z",
    fill: "url(#paint56_radial_4002_1667)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1594 13.7388C11.4167 15.6911 13.0782 17.1446 15.0451 17.1446H16.9317C18.8987 17.1446 20.5601 15.6911 20.8174 13.7388C20.9354 11.8551 21.054 9.97893 21.1415 8.09624C21.1309 7.32924 20.5263 6.69633 19.7625 6.66415H18.3623C17.4077 6.66415 16.5431 6.10097 16.1507 5.22134C16.0499 4.96925 15.8059 4.80298 15.5354 4.80298H14.2625C12.4168 4.80298 10.9211 6.31551 10.9211 8.18205C10.9211 10.0428 11.0374 11.8734 11.1594 13.7388Z",
    fill: "url(#paint57_radial_4002_1667)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1594 13.7388C11.4167 15.6911 13.0782 17.1446 15.0451 17.1446H16.9317C18.8987 17.1446 20.5601 15.6911 20.8174 13.7388C20.9354 11.8551 21.054 9.97893 21.1415 8.09624C21.1309 7.32924 20.5263 6.69633 19.7625 6.66415H18.3623C17.4077 6.66415 16.5431 6.10097 16.1507 5.22134C16.0499 4.96925 15.8059 4.80298 15.5354 4.80298H14.2625C12.4168 4.80298 10.9211 6.31551 10.9211 8.18205C10.9211 10.0428 11.0374 11.8734 11.1594 13.7388Z",
    fill: "url(#paint58_radial_4002_1667)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1594 13.7388C11.4167 15.6911 13.0782 17.1446 15.0451 17.1446H16.9317C18.8987 17.1446 20.5601 15.6911 20.8174 13.7388C20.9354 11.8551 21.054 9.97893 21.1415 8.09624C21.1309 7.32924 20.5263 6.69633 19.7625 6.66415H18.3623C17.4077 6.66415 16.5431 6.10097 16.1507 5.22134C16.0499 4.96925 15.8059 4.80298 15.5354 4.80298H14.2625C12.4168 4.80298 10.9211 6.31551 10.9211 8.18205C10.9211 10.0428 11.0374 11.8734 11.1594 13.7388Z",
    fill: "url(#paint59_radial_4002_1667)"
  })), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter16_f_4002_1667)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.5828 10.45L14.992 12.2883C14.891 12.6664 15.1333 13.0446 15.4764 13.0446H16.2081C16.5512 13.0446 16.7934 12.6606 16.6925 12.2883L16.198 10.45C16.092 10.0427 15.6938 10.0427 15.5828 10.45Z",
    fill: "#D69790"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter17_f_4002_1667)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.6018 10.259L15.0704 12.0974C14.9619 12.4755 15.2222 12.8537 15.591 12.8537H16.3773C16.7461 12.8537 17.0064 12.4697 16.898 12.0974L16.3665 10.259C16.2526 9.85181 15.7211 9.85181 15.6018 10.259Z",
    fill: "#F6BFAB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6018 10.259L15.0704 12.0974C14.9619 12.4755 15.2222 12.8537 15.591 12.8537H16.3773C16.7461 12.8537 17.0064 12.4697 16.898 12.0974L16.3665 10.259C16.2526 9.85181 15.7211 9.85181 15.6018 10.259Z",
    fill: "url(#paint60_linear_4002_1667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6018 10.259L15.0704 12.0974C14.9619 12.4755 15.2222 12.8537 15.591 12.8537H16.3773C16.7461 12.8537 17.0064 12.4697 16.898 12.0974L16.3665 10.259C16.2526 9.85181 15.7211 9.85181 15.6018 10.259Z",
    fill: "url(#paint61_radial_4002_1667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6018 10.259L15.0704 12.0974C14.9619 12.4755 15.2222 12.8537 15.591 12.8537H16.3773C16.7461 12.8537 17.0064 12.4697 16.898 12.0974L16.3665 10.259C16.2526 9.85181 15.7211 9.85181 15.6018 10.259Z",
    fill: "url(#paint62_linear_4002_1667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6018 10.259L15.0704 12.0974C14.9619 12.4755 15.2222 12.8537 15.591 12.8537H16.3773C16.7461 12.8537 17.0064 12.4697 16.898 12.0974L16.3665 10.259C16.2526 9.85181 15.7211 9.85181 15.6018 10.259Z",
    fill: "url(#paint63_radial_4002_1667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6018 10.259L15.0704 12.0974C14.9619 12.4755 15.2222 12.8537 15.591 12.8537H16.3773C16.7461 12.8537 17.0064 12.4697 16.898 12.0974L16.3665 10.259C16.2526 9.85181 15.7211 9.85181 15.6018 10.259Z",
    fill: "url(#paint64_linear_4002_1667)"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter18_f_4002_1667)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.6333 13.4754L14.6333 13.4754L14.6326 13.4751C14.5307 13.4232 14.4245 13.4558 14.3616 13.522C14.2983 13.5886 14.2726 13.6969 14.3386 13.7929C14.6871 14.3205 15.2936 14.6719 15.9841 14.6719C16.6748 14.6719 17.2815 14.3203 17.63 13.7924C17.6948 13.695 17.6708 13.5868 17.6062 13.5197C17.5426 13.4536 17.4364 13.4238 17.3355 13.4751L17.3355 13.4751L17.3348 13.4754C16.945 13.6787 16.485 13.7953 15.9841 13.7953C15.4882 13.7953 15.0231 13.6786 14.6333 13.4754Z",
    stroke: "url(#paint65_linear_4002_1667)",
    strokeWidth: 0.15
  }))), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9841 13.8703C15.4766 13.8703 14.9996 13.7509 14.5986 13.5419C14.4616 13.4722 14.3145 13.6265 14.4007 13.7509C14.7357 14.2585 15.3193 14.5969 15.9841 14.5969C16.6489 14.5969 17.2325 14.2585 17.5674 13.7509C17.6537 13.6215 17.5065 13.4722 17.3695 13.5419C16.9686 13.7509 16.4966 13.8703 15.9841 13.8703Z",
    fill: "url(#paint66_radial_4002_1667)"
  })), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter19_ii_4002_1667)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.8389 4.33091C21.3534 4.50791 21.8148 4.86727 22.1065 5.38218C22.5732 6.20281 22.5043 7.18435 22.0004 7.90844C21.8254 8.16589 21.7299 8.47162 21.7299 8.78271V9.97075C21.5429 9.84045 21.2961 9.74385 21.0627 9.70257L21.1412 8.09616C21.1306 7.32917 20.526 6.69626 19.7622 6.66408H18.362C17.4074 6.66408 16.5429 6.1009 16.1504 5.22127C16.0496 4.96918 15.8056 4.80291 15.5351 4.80291H14.2622C12.4165 4.80291 10.9209 6.31545 10.9209 8.18198L10.9515 9.71933C10.6975 9.75665 10.4322 9.84155 10.2314 9.983V8.78271C10.2314 8.47162 10.1359 8.16589 9.96087 7.90844C9.48353 7.2058 9.39867 6.26181 9.81767 5.46263C10.1094 4.91018 10.5814 4.524 11.1171 4.33627C11.6899 4.13246 12.1778 3.74628 12.5014 3.22601C12.9151 2.56628 13.6417 2.12646 14.4744 2.12646C14.7979 2.12646 15.1055 2.19619 15.3919 2.31419C15.7738 2.48046 16.2034 2.48046 16.5853 2.31419C16.8664 2.19619 17.174 2.12646 17.4975 2.12646C18.3408 2.12646 19.0781 2.58237 19.4864 3.25819C19.7941 3.76773 20.2767 4.13782 20.8389 4.33091Z",
    fill: "url(#paint67_linear_4002_1667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8389 4.33091C21.3534 4.50791 21.8148 4.86727 22.1065 5.38218C22.5732 6.20281 22.5043 7.18435 22.0004 7.90844C21.8254 8.16589 21.7299 8.47162 21.7299 8.78271V9.97075C21.5429 9.84045 21.2961 9.74385 21.0627 9.70257L21.1412 8.09616C21.1306 7.32917 20.526 6.69626 19.7622 6.66408H18.362C17.4074 6.66408 16.5429 6.1009 16.1504 5.22127C16.0496 4.96918 15.8056 4.80291 15.5351 4.80291H14.2622C12.4165 4.80291 10.9209 6.31545 10.9209 8.18198L10.9515 9.71933C10.6975 9.75665 10.4322 9.84155 10.2314 9.983V8.78271C10.2314 8.47162 10.1359 8.16589 9.96087 7.90844C9.48353 7.2058 9.39867 6.26181 9.81767 5.46263C10.1094 4.91018 10.5814 4.524 11.1171 4.33627C11.6899 4.13246 12.1778 3.74628 12.5014 3.22601C12.9151 2.56628 13.6417 2.12646 14.4744 2.12646C14.7979 2.12646 15.1055 2.19619 15.3919 2.31419C15.7738 2.48046 16.2034 2.48046 16.5853 2.31419C16.8664 2.19619 17.174 2.12646 17.4975 2.12646C18.3408 2.12646 19.0781 2.58237 19.4864 3.25819C19.7941 3.76773 20.2767 4.13782 20.8389 4.33091Z",
    fill: "url(#paint68_radial_4002_1667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8389 4.33091C21.3534 4.50791 21.8148 4.86727 22.1065 5.38218C22.5732 6.20281 22.5043 7.18435 22.0004 7.90844C21.8254 8.16589 21.7299 8.47162 21.7299 8.78271V9.97075C21.5429 9.84045 21.2961 9.74385 21.0627 9.70257L21.1412 8.09616C21.1306 7.32917 20.526 6.69626 19.7622 6.66408H18.362C17.4074 6.66408 16.5429 6.1009 16.1504 5.22127C16.0496 4.96918 15.8056 4.80291 15.5351 4.80291H14.2622C12.4165 4.80291 10.9209 6.31545 10.9209 8.18198L10.9515 9.71933C10.6975 9.75665 10.4322 9.84155 10.2314 9.983V8.78271C10.2314 8.47162 10.1359 8.16589 9.96087 7.90844C9.48353 7.2058 9.39867 6.26181 9.81767 5.46263C10.1094 4.91018 10.5814 4.524 11.1171 4.33627C11.6899 4.13246 12.1778 3.74628 12.5014 3.22601C12.9151 2.56628 13.6417 2.12646 14.4744 2.12646C14.7979 2.12646 15.1055 2.19619 15.3919 2.31419C15.7738 2.48046 16.2034 2.48046 16.5853 2.31419C16.8664 2.19619 17.174 2.12646 17.4975 2.12646C18.3408 2.12646 19.0781 2.58237 19.4864 3.25819C19.7941 3.76773 20.2767 4.13782 20.8389 4.33091Z",
    fill: "url(#paint69_radial_4002_1667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8389 4.33091C21.3534 4.50791 21.8148 4.86727 22.1065 5.38218C22.5732 6.20281 22.5043 7.18435 22.0004 7.90844C21.8254 8.16589 21.7299 8.47162 21.7299 8.78271V9.97075C21.5429 9.84045 21.2961 9.74385 21.0627 9.70257L21.1412 8.09616C21.1306 7.32917 20.526 6.69626 19.7622 6.66408H18.362C17.4074 6.66408 16.5429 6.1009 16.1504 5.22127C16.0496 4.96918 15.8056 4.80291 15.5351 4.80291H14.2622C12.4165 4.80291 10.9209 6.31545 10.9209 8.18198L10.9515 9.71933C10.6975 9.75665 10.4322 9.84155 10.2314 9.983V8.78271C10.2314 8.47162 10.1359 8.16589 9.96087 7.90844C9.48353 7.2058 9.39867 6.26181 9.81767 5.46263C10.1094 4.91018 10.5814 4.524 11.1171 4.33627C11.6899 4.13246 12.1778 3.74628 12.5014 3.22601C12.9151 2.56628 13.6417 2.12646 14.4744 2.12646C14.7979 2.12646 15.1055 2.19619 15.3919 2.31419C15.7738 2.48046 16.2034 2.48046 16.5853 2.31419C16.8664 2.19619 17.174 2.12646 17.4975 2.12646C18.3408 2.12646 19.0781 2.58237 19.4864 3.25819C19.7941 3.76773 20.2767 4.13782 20.8389 4.33091Z",
    fill: "url(#paint70_radial_4002_1667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8389 4.33091C21.3534 4.50791 21.8148 4.86727 22.1065 5.38218C22.5732 6.20281 22.5043 7.18435 22.0004 7.90844C21.8254 8.16589 21.7299 8.47162 21.7299 8.78271V9.97075C21.5429 9.84045 21.2961 9.74385 21.0627 9.70257L21.1412 8.09616C21.1306 7.32917 20.526 6.69626 19.7622 6.66408H18.362C17.4074 6.66408 16.5429 6.1009 16.1504 5.22127C16.0496 4.96918 15.8056 4.80291 15.5351 4.80291H14.2622C12.4165 4.80291 10.9209 6.31545 10.9209 8.18198L10.9515 9.71933C10.6975 9.75665 10.4322 9.84155 10.2314 9.983V8.78271C10.2314 8.47162 10.1359 8.16589 9.96087 7.90844C9.48353 7.2058 9.39867 6.26181 9.81767 5.46263C10.1094 4.91018 10.5814 4.524 11.1171 4.33627C11.6899 4.13246 12.1778 3.74628 12.5014 3.22601C12.9151 2.56628 13.6417 2.12646 14.4744 2.12646C14.7979 2.12646 15.1055 2.19619 15.3919 2.31419C15.7738 2.48046 16.2034 2.48046 16.5853 2.31419C16.8664 2.19619 17.174 2.12646 17.4975 2.12646C18.3408 2.12646 19.0781 2.58237 19.4864 3.25819C19.7941 3.76773 20.2767 4.13782 20.8389 4.33091Z",
    fill: "url(#paint71_radial_4002_1667)"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter20_i_4002_1667)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.7169 7.99422C19.5417 7.84163 19.338 7.67995 19.0294 7.5828C18.7252 7.48703 18.3441 7.4613 17.8169 7.52579C17.6649 7.54439 17.5567 7.68272 17.5753 7.83474C17.5939 7.98677 17.7322 8.09494 17.8843 8.07634C18.3654 8.01747 18.6602 8.04806 18.8628 8.11186C19.0611 8.17428 19.1953 8.27541 19.3526 8.41246C19.4681 8.51306 19.6433 8.50098 19.7439 8.38548C19.8445 8.26999 19.8324 8.09481 19.7169 7.99422Z",
    fill: "#202020"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter21_i_4002_1667)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5734 7.88508C12.6635 7.83114 12.7932 7.76214 12.957 7.69775C13.2844 7.56901 13.7524 7.45719 14.3123 7.5257C14.4644 7.5443 14.5725 7.68262 14.5539 7.83465C14.5353 7.98668 14.397 8.09484 14.245 8.07624C13.7966 8.02139 13.4225 8.11071 13.1599 8.21394C13.0287 8.26554 12.9264 8.32024 12.8583 8.361C12.8243 8.38134 12.799 8.39808 12.7832 8.40904C12.7752 8.41452 12.7697 8.41853 12.7666 8.42081L12.7638 8.42287C12.643 8.51604 12.4694 8.49409 12.3756 8.3735C12.2815 8.2526 12.3033 8.07837 12.4242 7.98433L12.5734 7.88508Z",
    fill: "#202020"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter22_if_4002_1667)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.2166 5.35806C16.1933 5.31337 16.1712 5.26775 16.1505 5.22125C16.0497 4.96916 15.8057 4.80289 15.5352 4.80289H14.2623C12.4166 4.80289 10.921 6.31543 10.921 8.18197V8.45713C10.581 8.19839 10.1533 7.65258 10.1533 6.76933C10.1533 5.69749 10.9351 5.15572 11.4337 4.81013C11.5745 4.71257 11.6927 4.63064 11.7644 4.55684C11.7948 4.52548 11.828 4.49032 11.8641 4.45207C12.2136 4.08135 12.8364 3.42081 13.9239 3.13213C14.4554 2.99106 14.9938 2.95654 15.4316 2.9671C15.9043 2.97851 16.2377 3.38678 16.2377 3.85963V5.34462L16.2166 5.35806Z",
    fill: "#23181C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2166 5.35806C16.1933 5.31337 16.1712 5.26775 16.1505 5.22125C16.0497 4.96916 15.8057 4.80289 15.5352 4.80289H14.2623C12.4166 4.80289 10.921 6.31543 10.921 8.18197V8.45713C10.581 8.19839 10.1533 7.65258 10.1533 6.76933C10.1533 5.69749 10.9351 5.15572 11.4337 4.81013C11.5745 4.71257 11.6927 4.63064 11.7644 4.55684C11.7948 4.52548 11.828 4.49032 11.8641 4.45207C12.2136 4.08135 12.8364 3.42081 13.9239 3.13213C14.4554 2.99106 14.9938 2.95654 15.4316 2.9671C15.9043 2.97851 16.2377 3.38678 16.2377 3.85963V5.34462L16.2166 5.35806Z",
    fill: "url(#paint72_radial_4002_1667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2166 5.35806C16.1933 5.31337 16.1712 5.26775 16.1505 5.22125C16.0497 4.96916 15.8057 4.80289 15.5352 4.80289H14.2623C12.4166 4.80289 10.921 6.31543 10.921 8.18197V8.45713C10.581 8.19839 10.1533 7.65258 10.1533 6.76933C10.1533 5.69749 10.9351 5.15572 11.4337 4.81013C11.5745 4.71257 11.6927 4.63064 11.7644 4.55684C11.7948 4.52548 11.828 4.49032 11.8641 4.45207C12.2136 4.08135 12.8364 3.42081 13.9239 3.13213C14.4554 2.99106 14.9938 2.95654 15.4316 2.9671C15.9043 2.97851 16.2377 3.38678 16.2377 3.85963V5.34462L16.2166 5.35806Z",
    fill: "url(#paint73_radial_4002_1667)"
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter23_f_4002_1667)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.1969 8.62478L21.1677 7.99359C21.1571 7.23014 20.5262 6.60015 19.7625 6.56812H18.3623C17.4734 6.56812 16.6627 6.08216 16.2384 5.30847C16.2384 5.30847 16.1798 5.17277 16.1184 4.94034C15.8621 3.97055 16.7893 3.22801 17.774 3.41899C18.7474 3.60778 19.8562 3.93589 20.6761 4.47062C22.4206 5.60847 22.1152 7.65911 21.1969 8.62478Z",
    fill: "#1F151B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1969 8.62478L21.1677 7.99359C21.1571 7.23014 20.5262 6.60015 19.7625 6.56812H18.3623C17.4734 6.56812 16.6627 6.08216 16.2384 5.30847C16.2384 5.30847 16.1798 5.17277 16.1184 4.94034C15.8621 3.97055 16.7893 3.22801 17.774 3.41899C18.7474 3.60778 19.8562 3.93589 20.6761 4.47062C22.4206 5.60847 22.1152 7.65911 21.1969 8.62478Z",
    fill: "url(#paint74_radial_4002_1667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1969 8.62478L21.1677 7.99359C21.1571 7.23014 20.5262 6.60015 19.7625 6.56812H18.3623C17.4734 6.56812 16.6627 6.08216 16.2384 5.30847C16.2384 5.30847 16.1798 5.17277 16.1184 4.94034C15.8621 3.97055 16.7893 3.22801 17.774 3.41899C18.7474 3.60778 19.8562 3.93589 20.6761 4.47062C22.4206 5.60847 22.1152 7.65911 21.1969 8.62478Z",
    fill: "url(#paint75_radial_4002_1667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1969 8.62478L21.1677 7.99359C21.1571 7.23014 20.5262 6.60015 19.7625 6.56812H18.3623C17.4734 6.56812 16.6627 6.08216 16.2384 5.30847C16.2384 5.30847 16.1798 5.17277 16.1184 4.94034C15.8621 3.97055 16.7893 3.22801 17.774 3.41899C18.7474 3.60778 19.8562 3.93589 20.6761 4.47062C22.4206 5.60847 22.1152 7.65911 21.1969 8.62478Z",
    fill: "url(#paint76_radial_4002_1667)"
  }))), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3751 9.30884C19.0283 9.30884 19.5799 9.75912 19.73 10.3676C19.7747 10.542 19.6408 10.7084 19.4623 10.7084H17.2312C17.0892 10.7084 16.9756 10.5786 17.004 10.4366C17.1298 9.79563 17.6936 9.30884 18.3751 9.30884Z",
    fill: "white"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1682 9.58057C18.6631 9.58057 19.0607 9.98217 19.0607 10.473C19.0607 10.5541 19.0485 10.6353 19.0282 10.7083H17.3042C17.2839 10.6312 17.2717 10.5541 17.2717 10.473C17.2717 9.98217 17.6733 9.58057 18.1682 9.58057Z",
    fill: "url(#paint77_radial_4002_1667)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6571 10.473C17.6571 10.1891 17.8843 9.96191 18.1682 9.96191C18.4522 9.96191 18.6794 10.1891 18.6794 10.473C18.6794 10.5582 18.6591 10.6394 18.6226 10.7083H17.718C17.6774 10.6394 17.6571 10.5582 17.6571 10.473Z",
    fill: "black"
  })), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter24_f_4002_1667)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.1025 9.76924C18.1661 9.85429 18.0332 9.95796 17.8821 10.0709C17.731 10.1839 17.6189 10.2634 17.5553 10.1784C17.4917 10.0934 17.5627 9.93282 17.7138 9.81984C17.8649 9.70686 18.039 9.6842 18.1025 9.76924Z",
    fill: "#C7A7A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1025 9.76924C18.1661 9.85429 18.0332 9.95796 17.8821 10.0709C17.731 10.1839 17.6189 10.2634 17.5553 10.1784C17.4917 10.0934 17.5627 9.93282 17.7138 9.81984C17.8649 9.70686 18.039 9.6842 18.1025 9.76924Z",
    fill: "url(#paint78_radial_4002_1667)"
  }))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter25_f_4002_1667)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.9633 10.3555C18.9303 10.1248 18.7953 9.95092 18.7319 9.89282L18.472 10.1781L18.5893 10.4062L18.9633 10.3555Z",
    fill: "url(#paint79_linear_4002_1667)"
  }))), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5932 9.30884C12.9401 9.30884 12.3884 9.75914 12.2383 10.3677C12.1936 10.5421 12.3275 10.7084 12.506 10.7084H14.7373C14.8792 10.7084 14.9928 10.5786 14.9644 10.4366C14.8387 9.79565 14.2707 9.30884 13.5932 9.30884Z",
    fill: "white"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8001 9.58057C13.3052 9.58057 12.9076 9.98219 12.9076 10.4731C12.9076 10.5542 12.9198 10.6353 12.94 10.7084H14.6642C14.6845 10.6313 14.6966 10.5542 14.6966 10.4731C14.6926 9.98219 14.295 9.58057 13.8001 9.58057Z",
    fill: "url(#paint80_radial_4002_1667)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3113 10.4731C14.3113 10.1891 14.0841 9.96191 13.8001 9.96191C13.5161 9.96191 13.2889 10.1891 13.2889 10.4731C13.2889 10.5583 13.3092 10.6394 13.3457 10.7084H14.2504C14.2869 10.6394 14.3113 10.5583 14.3113 10.4731Z",
    fill: "black"
  })), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter26_f_4002_1667)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.6155 10.3681C14.6155 10.0797 14.381 9.88745 14.3176 9.82935L14.0292 10.1083L14.2067 10.4696L14.6155 10.3681Z",
    fill: "url(#paint81_linear_4002_1667)"
  }))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter27_f_4002_1667)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 13.5308,
    cy: 9.96181,
    rx: 0.389622,
    ry: 0.197185,
    transform: "rotate(-27.914 13.5308 9.96181)",
    fill: "#C7A7A3",
    fillOpacity: 0.9
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 13.5308,
    cy: 9.96181,
    rx: 0.389622,
    ry: 0.197185,
    transform: "rotate(-27.914 13.5308 9.96181)",
    fill: "url(#paint82_radial_4002_1667)"
  }))), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9061 12.3146C20.9719 11.2504 21.0354 10.1875 21.0907 9.12329C21.8463 9.25549 22.4206 9.9148 22.4206 10.7082C22.4206 11.5651 21.7507 12.2656 20.9061 12.3146Z",
    fill: "url(#paint83_linear_4002_1667)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9061 12.3146C20.9719 11.2504 21.0354 10.1875 21.0907 9.12329C21.8463 9.25549 22.4206 9.9148 22.4206 10.7082C22.4206 11.5651 21.7507 12.2656 20.9061 12.3146Z",
    fill: "url(#paint84_radial_4002_1667)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9061 12.3146C20.9719 11.2504 21.0354 10.1875 21.0907 9.12329C21.8463 9.25549 22.4206 9.9148 22.4206 10.7082C22.4206 11.5651 21.7507 12.2656 20.9061 12.3146Z",
    fill: "url(#paint85_radial_4002_1667)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9061 12.3146C20.9719 11.2504 21.0354 10.1875 21.0907 9.12329C21.8463 9.25549 22.4206 9.9148 22.4206 10.7082C22.4206 11.5651 21.7507 12.2656 20.9061 12.3146Z",
    fill: "url(#paint86_radial_4002_1667)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9398 9.1145C10.1585 9.22467 9.54773 9.89658 9.54773 10.7083C9.54773 11.5674 10.2209 12.2692 11.0686 12.315C11.004 11.2465 10.9605 10.1834 10.9398 9.1145Z",
    fill: "url(#paint87_linear_4002_1667)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9398 9.1145C10.1585 9.22467 9.54773 9.89658 9.54773 10.7083C9.54773 11.5674 10.2209 12.2692 11.0686 12.315C11.004 11.2465 10.9605 10.1834 10.9398 9.1145Z",
    fill: "url(#paint88_radial_4002_1667)"
  })), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter28_f_4002_1667)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.8988 9.77539C10.4721 9.87105 10.1533 10.2521 10.1533 10.7076C10.1533 11.1924 10.5144 11.5929 10.9822 11.6547C10.9476 11.0279 10.9183 10.4023 10.8988 9.77539Z",
    fill: "url(#paint89_radial_4002_1667)"
  }))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter29_f_4002_1667)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.9899 11.6707C21.0284 11.0361 21.0657 10.4019 21.1005 9.76733C21.5717 9.82613 21.9364 10.2281 21.9364 10.7153C21.9364 11.24 21.5134 11.6659 20.9899 11.6707Z",
    fill: "url(#paint90_linear_4002_1667)"
  }))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter30_f_4002_1667)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.6108 8.16484C12.8678 7.98047 13.5084 7.65614 14.266 7.78352",
    stroke: "#353535",
    strokeWidth: 0.25,
    strokeLinecap: "round"
  }))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter31_f_4002_1667)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.5452 8.1187C19.2882 7.93432 18.6476 7.61 17.89 7.73738",
    stroke: "#353535",
    strokeWidth: 0.25,
    strokeLinecap: "round"
  }))), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter32_ii_4002_1667)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.8341 8.50146H17.3641C17.0641 8.50146 16.7841 8.64147 16.5941 8.87147C16.4741 9.02147 16.2941 9.11146 16.0841 9.11146C15.8741 9.11146 15.6941 9.02147 15.5741 8.87147C15.3841 8.64147 15.1041 8.50146 14.8041 8.50146H11.3241C11.1341 8.50146 10.9841 8.65146 10.9841 8.84146V9.06147C10.9841 9.17147 11.0341 9.26147 11.1141 9.32147C11.1541 9.35147 11.1841 9.40147 11.1841 9.45147V10.5515C11.1841 11.6015 12.0341 12.4615 13.0941 12.4615H13.8041C14.8541 12.4615 15.7141 11.6115 15.7141 10.5515V9.94146C15.7241 9.74146 15.8841 9.59146 16.0841 9.59146C16.2841 9.59146 16.4441 9.75147 16.4541 9.95147C16.4541 10.1515 16.4541 10.3515 16.4541 10.5515C16.4541 11.6015 17.3041 12.4615 18.3641 12.4615H19.0741C20.1241 12.4615 20.9841 11.6115 20.9841 10.5515V9.44146C20.9841 9.39146 21.0041 9.34147 21.0441 9.31147C21.1241 9.25147 21.1741 9.15147 21.1741 9.05147V8.84146C21.1741 8.65146 21.0241 8.50146 20.8341 8.50146ZM15.3741 10.4515C15.3741 11.3615 14.6341 12.1015 13.7241 12.1015H13.1741C12.2641 12.1015 11.5241 11.3615 11.5241 10.4515V9.73146C11.5241 9.24146 11.9141 8.85147 12.4041 8.85147H14.4841C14.9741 8.85147 15.3741 9.24146 15.3741 9.73146V10.4515ZM20.6541 10.4515C20.6541 11.3615 19.9141 12.1015 19.0041 12.1015H18.4541C17.5441 12.1015 16.8041 11.3615 16.8041 10.4515V9.73146C16.8041 9.24146 17.1941 8.85147 17.6841 8.85147H19.7741C20.2641 8.85147 20.6541 9.24146 20.6541 9.73146V10.4515Z",
    fill: "url(#paint91_linear_4002_1667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8341 8.50146H17.3641C17.0641 8.50146 16.7841 8.64147 16.5941 8.87147C16.4741 9.02147 16.2941 9.11146 16.0841 9.11146C15.8741 9.11146 15.6941 9.02147 15.5741 8.87147C15.3841 8.64147 15.1041 8.50146 14.8041 8.50146H11.3241C11.1341 8.50146 10.9841 8.65146 10.9841 8.84146V9.06147C10.9841 9.17147 11.0341 9.26147 11.1141 9.32147C11.1541 9.35147 11.1841 9.40147 11.1841 9.45147V10.5515C11.1841 11.6015 12.0341 12.4615 13.0941 12.4615H13.8041C14.8541 12.4615 15.7141 11.6115 15.7141 10.5515V9.94146C15.7241 9.74146 15.8841 9.59146 16.0841 9.59146C16.2841 9.59146 16.4441 9.75147 16.4541 9.95147C16.4541 10.1515 16.4541 10.3515 16.4541 10.5515C16.4541 11.6015 17.3041 12.4615 18.3641 12.4615H19.0741C20.1241 12.4615 20.9841 11.6115 20.9841 10.5515V9.44146C20.9841 9.39146 21.0041 9.34147 21.0441 9.31147C21.1241 9.25147 21.1741 9.15147 21.1741 9.05147V8.84146C21.1741 8.65146 21.0241 8.50146 20.8341 8.50146ZM15.3741 10.4515C15.3741 11.3615 14.6341 12.1015 13.7241 12.1015H13.1741C12.2641 12.1015 11.5241 11.3615 11.5241 10.4515V9.73146C11.5241 9.24146 11.9141 8.85147 12.4041 8.85147H14.4841C14.9741 8.85147 15.3741 9.24146 15.3741 9.73146V10.4515ZM20.6541 10.4515C20.6541 11.3615 19.9141 12.1015 19.0041 12.1015H18.4541C17.5441 12.1015 16.8041 11.3615 16.8041 10.4515V9.73146C16.8041 9.24146 17.1941 8.85147 17.6841 8.85147H19.7741C20.2641 8.85147 20.6541 9.24146 20.6541 9.73146V10.4515Z",
    fill: "url(#paint92_radial_4002_1667)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_4002_1667",
    x: 2.00415,
    y: 4.01147,
    width: 27.9803,
    height: 21.09,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.81585 0 0 0 0 0.641744 0 0 0 0 0.41905 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_4002_1667"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_4002_1667",
    x: 2.66876,
    y: 3.85488,
    width: 27.4125,
    height: 20.7846,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.2,
    result: "effect1_foregroundBlur_4002_1667"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_i_4002_1667",
    x: 2.00415,
    y: 4.03154,
    width: 27.91,
    height: 20.9599,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.85098 0 0 0 0 0.482353 0 0 0 0 0.647059 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_4002_1667"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_i_4002_1667",
    x: 18.0542,
    y: 15.9715,
    width: 2.7968,
    height: 14.0399,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.125
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.380392 0 0 0 0 0.164706 0 0 0 0 0.203922 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_4002_1667"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_i_4002_1667",
    x: 11.1473,
    y: 15.9715,
    width: 2.7968,
    height: 14.0399,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.125
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.380392 0 0 0 0 0.164706 0 0 0 0 0.203922 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_4002_1667"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_i_4002_1667",
    x: 20.9475,
    y: 23.1194,
    width: 2.1,
    height: 3.39004,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.1,
    dy: 0.1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.968627 0 0 0 0 0.803922 0 0 0 0 0.713726 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_4002_1667"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_i_4002_1667",
    x: 8.95068,
    y: 23.1116,
    width: 2.1,
    height: 3.29004,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.125
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.886275 0 0 0 0 0.670588 0 0 0 0 0.588235 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_4002_1667"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_i_4002_1667",
    x: 8.95068,
    y: 24.6208,
    width: 4.79337,
    height: 5.39062,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.25
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.882353 0 0 0 0 0.670588 0 0 0 0 0.603922 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_4002_1667"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_ii_4002_1667",
    x: 18.4542,
    y: 24.4208,
    width: 4.79337,
    height: 5.59063,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.2,
    dy: -0.2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.25
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.74902 0 0 0 0 0.490196 0 0 0 0 0.478431 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_4002_1667"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.956863 0 0 0 0 0.796078 0 0 0 0 0.721569 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_4002_1667",
    result: "effect2_innerShadow_4002_1667"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_f_4002_1667",
    x: 18.8734,
    y: 25.9005,
    width: 2.22188,
    height: 0.300098,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.05,
    result: "effect1_foregroundBlur_4002_1667"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter10_f_4002_1667",
    x: 10.8605,
    y: 25.9005,
    width: 2.22188,
    height: 0.300098,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.05,
    result: "effect1_foregroundBlur_4002_1667"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter11_f_4002_1667",
    x: 18.8734,
    y: 27.1661,
    width: 2.22188,
    height: 0.300098,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.05,
    result: "effect1_foregroundBlur_4002_1667"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter12_f_4002_1667",
    x: 10.8605,
    y: 27.1661,
    width: 2.22188,
    height: 0.300098,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.05,
    result: "effect1_foregroundBlur_4002_1667"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter13_f_4002_1667",
    x: 18.8734,
    y: 28.4317,
    width: 2.22188,
    height: 0.300098,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.05,
    result: "effect1_foregroundBlur_4002_1667"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter14_f_4002_1667",
    x: 10.8605,
    y: 28.4317,
    width: 2.22188,
    height: 0.300098,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.05,
    result: "effect1_foregroundBlur_4002_1667"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter15_ii_4002_1667",
    x: 10.9211,
    y: 4.80298,
    width: 11.2204,
    height: 12.5416,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.7
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.913725 0 0 0 0 0.686275 0 0 0 0 0.592157 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_4002_1667"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.375
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.780392 0 0 0 0 0.568627 0 0 0 0 0.486275 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_4002_1667",
    result: "effect2_innerShadow_4002_1667"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter16_f_4002_1667",
    x: 13.9689,
    y: 9.14453,
    width: 3.74673,
    height: 4.90015,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "effect1_foregroundBlur_4002_1667"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter17_f_4002_1667",
    x: 14.8455,
    y: 9.75361,
    width: 2.27726,
    height: 3.30015,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.1,
    result: "effect1_foregroundBlur_4002_1667"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter18_f_4002_1667",
    x: 14.1248,
    y: 13.274,
    width: 3.71845,
    height: 1.5728,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.05,
    result: "effect1_foregroundBlur_4002_1667"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter19_ii_4002_1667",
    x: 9.54773,
    y: 1.62646,
    width: 12.8727,
    height: 8.35645,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.625
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.137255 0 0 0 0 0.0901961 0 0 0 0 0.145098 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_4002_1667"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0784314 0 0 0 0 0.0352941 0 0 0 0 0.0470588 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_4002_1667",
    result: "effect2_innerShadow_4002_1667"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter20_i_4002_1667",
    x: 17.5732,
    y: 7.29023,
    width: 2.33886,
    height: 1.19048,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.1,
    dy: -0.2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.125
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0588235 0 0 0 0 0.054902 0 0 0 0 0.0588235 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_4002_1667"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter21_i_4002_1667",
    x: 12.3171,
    y: 7.30488,
    width: 2.33886,
    height: 1.17559,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.1,
    dy: -0.2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.125
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0588235 0 0 0 0 0.054902 0 0 0 0 0.0588235 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_4002_1667"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter22_if_4002_1667",
    x: 9.90332,
    y: 2.71533,
    width: 6.73435,
    height: 5.9917,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.4,
    dy: 0.2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.286275 0 0 0 0 0.243137 0 0 0 0 0.227451 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_4002_1667"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.125,
    result: "effect2_foregroundBlur_4002_1667"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter23_f_4002_1667",
    x: 15.8252,
    y: 3.13892,
    width: 6.36148,
    height: 5.73584,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.125,
    result: "effect1_foregroundBlur_4002_1667"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter24_f_4002_1667",
    x: 17.432,
    y: 9.61777,
    width: 0.786838,
    height: 0.696338,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.05,
    result: "effect1_foregroundBlur_4002_1667"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter25_f_4002_1667",
    x: 18.272,
    y: 9.69282,
    width: 0.891226,
    height: 0.913428,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.1,
    result: "effect1_foregroundBlur_4002_1667"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter26_f_4002_1667",
    x: 13.8292,
    y: 9.62935,
    width: 0.986334,
    height: 1.04014,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.1,
    result: "effect1_foregroundBlur_4002_1667"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter27_f_4002_1667",
    x: 13.0743,
    y: 9.60947,
    width: 0.913074,
    height: 0.704639,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.05,
    result: "effect1_foregroundBlur_4002_1667"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter28_f_4002_1667",
    x: 9.90332,
    y: 9.52539,
    width: 1.3289,
    height: 2.37939,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.125,
    result: "effect1_foregroundBlur_4002_1667"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter29_f_4002_1667",
    x: 20.4899,
    y: 9.26733,
    width: 1.94653,
    height: 2.90332,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.25,
    result: "effect1_foregroundBlur_4002_1667"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter30_f_4002_1667",
    x: 12.2358,
    y: 7.37964,
    width: 2.40521,
    height: 1.16016,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.125,
    result: "effect1_foregroundBlur_4002_1667"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter31_f_4002_1667",
    x: 17.515,
    y: 7.3335,
    width: 2.40521,
    height: 1.16016,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.125,
    result: "effect1_foregroundBlur_4002_1667"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter32_ii_4002_1667",
    x: 10.8841,
    y: 8.40146,
    width: 10.29,
    height: 4.15996,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.1,
    dy: 0.1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.381221 0 0 0 0 0.2699 0 0 0 0 0.482422 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_4002_1667"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.05
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.2 0 0 0 0 0.109804 0 0 0 0 0.211765 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_4002_1667",
    result: "effect2_innerShadow_4002_1667"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4002_1667",
    x1: 11.8185,
    y1: 4.62043,
    x2: 31.2612,
    y2: 22.8559,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFBE85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.567876,
    stopColor: "#E8AC81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D6753D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4002_1667",
    x1: 30.0625,
    y1: 13.3083,
    x2: 9.12496,
    y2: 13.3083,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#509245"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#44803D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_4002_1667",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(6.43745 25.7458) rotate(-56.7456) scale(18.2363 24.9585)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25585F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#25585F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_4002_1667",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(29.5625 25.4959) rotate(-125.417) scale(17.2555 17.0682)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#358175"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#358175",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_4002_1667",
    x1: 13.4375,
    y1: 3.56104,
    x2: 31.25,
    y2: 24.3735,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD59C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F69C5B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_4002_1667",
    x1: -4.9063,
    y1: 25.6522,
    x2: 28.9062,
    y2: 25.6522,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D18F7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1B58B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_4002_1667",
    x1: 3.0937,
    y1: 5.21467,
    x2: 3.0937,
    y2: 23.6522,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D78248"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D78248",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_4002_1667",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(2.00415 4.33154) rotate(90) scale(9.31138 0.617645)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.355159,
    stopColor: "#BC7B53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BC7B53",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_4002_1667",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15.9999 15.9646) rotate(90) scale(14.0469 6.21865)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#61342D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#764747"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_4002_1667",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.6562 20.4958) rotate(90) scale(8.375 2.9375)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9A6D66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9A6D66",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_4002_1667",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(12.7187 19.0896) rotate(135) scale(2.16551 1.74567)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#61332B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#61332B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_4002_1667",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(26.9942 28.246) rotate(-90) scale(10.1875 3.85106)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7C5A5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#735451"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_4002_1667",
    x1: 25.1736,
    y1: 30.4657,
    x2: 25.1736,
    y2: 26.6488,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#614451"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#614451",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_4002_1667",
    x1: 22.4063,
    y1: 29.2772,
    x2: 23.2187,
    y2: 29.2616,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.253974,
    stopColor: "#4F2737"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F2737",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_4002_1667",
    x1: 7.13419,
    y1: 28.1588,
    x2: 9.52873,
    y2: 28.1588,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#623D44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F2E37"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial_4002_1667",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.4581 29.7946) rotate(180) scale(6.92068 17.2807)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.575758,
    stopColor: "#5D3841",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7F6260"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint16_radial_4002_1667",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15.1875 20.3084) scale(3.59375 11.7969)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ABA5A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#544B50"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_4002_1667",
    x1: 18.0542,
    y1: 18.3859,
    x2: 20.851,
    y2: 18.3859,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#613327"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.371011,
    stopColor: "#764440"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint18_radial_4002_1667",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(21.231 19.4554) rotate(-115.221) scale(3.74046 2.26254)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#90645E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#90645E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint19_radial_4002_1667",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(19.6719 20.4647) rotate(-125.283) scale(1.63656 0.298059)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8A5D57"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8A5D57",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint20_radial_4002_1667",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(17.9671 16.4803) rotate(69.6775) scale(0.949744 1.77775)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.358549,
    stopColor: "#481E13"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4A1D14",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_4002_1667",
    x1: 13.9441,
    y1: 18.3859,
    x2: 11.1473,
    y2: 18.3859,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#744036"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.639259,
    stopColor: "#72433E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint22_radial_4002_1667",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.5156 20.3709) rotate(-88.8542) scale(3.12562 1.26257)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#875955"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#875955",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_4002_1667",
    x1: 12.1093,
    y1: 16.949,
    x2: 12.6718,
    y2: 17.1678,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6F5048"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F5048",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint24_radial_4002_1667",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.0312 16.4803) rotate(115.115) scale(1.10441 2.06726)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.219333,
    stopColor: "#481E13"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4A1D14",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint25_radial_4002_1667",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.0041 17.2458) rotate(90) scale(2.81101 2.05629)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.298184,
    stopColor: "#A87366"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#875841"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint26_radial_4002_1667",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.6367 23.7825) rotate(136.93) scale(1.54538 2.22628)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.280493,
    stopColor: "#E9BDA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDA88B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint27_radial_4002_1667",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.7787 23.501) rotate(-40.3999) scale(0.812845 0.484207)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCD2BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCD2BC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint28_radial_4002_1667",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.0937 24.0244) rotate(-170.853) scale(1.8675 5.85149)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B88165"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CD9A86"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_4002_1667",
    x1: 21.8437,
    y1: 24.8084,
    x2: 17.4687,
    y2: 24.8084,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9266F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BF1B74"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_4002_1667",
    x1: 10.3141,
    y1: 23.5896,
    x2: 10.7421,
    y2: 23.5896,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6D6670"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D6670",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_4002_1667",
    x1: 12.8629,
    y1: 28.0271,
    x2: 8.56248,
    y2: 28.0271,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAB9AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.716025,
    stopColor: "#D4A093"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint32_radial_4002_1667",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(12.1875 25.3762) rotate(-180) scale(1.67187 0.659547)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2C6BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2C6BB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint33_radial_4002_1667",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(12.2031 26.6574) rotate(180) scale(1.53125 0.604071)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2C6BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2C6BB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint34_radial_4002_1667",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(12.25 27.9387) rotate(180) scale(1.34375 0.530103)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2C6BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2C6BB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint35_radial_4002_1667",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(12.3203 29.298) rotate(180) scale(1.5 0.591743)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2C6BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2C6BB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_4002_1667",
    x1: 11.0625,
    y1: 30.2812,
    x2: 11.0625,
    y2: 29.203,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C38792"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C38792",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_4002_1667",
    x1: 22.4687,
    y1: 27.6208,
    x2: 18.6542,
    y2: 27.6208,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD7C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.806957,
    stopColor: "#D19890"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint38_radial_4002_1667",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(21.25 25.3762) scale(1.70312 0.671875)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD6C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD6C4",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint39_radial_4002_1667",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(21.1875 26.6574) scale(1.625 0.641055)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD6C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD6C4",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint40_radial_4002_1667",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(21.0937 27.9387) scale(1.5625 0.616399)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD6C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD6C4",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint41_radial_4002_1667",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(20.9531 29.298) scale(1.4375 0.567087)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD6C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD6C4",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_4002_1667",
    x1: 10.7812,
    y1: 21.9647,
    x2: 21.6541,
    y2: 21.9647,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#564567"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#564567"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_4002_1667",
    x1: 16.4007,
    y1: 21.0271,
    x2: 16.4007,
    y2: 22.199,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DCD5E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B2ACB9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_4002_1667",
    x1: 19.0234,
    y1: 26.1287,
    x2: 20.8516,
    y2: 26.1287,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B6736C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B6736C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_4002_1667",
    x1: 12.9324,
    y1: 26.1287,
    x2: 10.7344,
    y2: 26.1287,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4AF9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D29C80",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4AF9D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_4002_1667",
    x1: 19.0234,
    y1: 27.3943,
    x2: 20.8516,
    y2: 27.3943,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B6736C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B6736C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_4002_1667",
    x1: 12.9324,
    y1: 27.3943,
    x2: 10.7344,
    y2: 27.3943,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4AF9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D29C80",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4AF9D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_4002_1667",
    x1: 19.0234,
    y1: 28.6599,
    x2: 20.8516,
    y2: 28.6599,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B6736C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B6736C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_4002_1667",
    x1: 12.9324,
    y1: 28.6599,
    x2: 10.7344,
    y2: 28.6599,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4AF9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D29C80",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4AF9D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint50_radial_4002_1667",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(20.7375 11.915) rotate(69.6569) scale(2.15387 2.55864)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.214643,
    stopColor: "#313131"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A161E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint51_radial_4002_1667",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(9.9277 12.4054) rotate(17.4472) scale(1.54766 4.77464)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#564943"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.745836,
    stopColor: "#1E191C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint52_radial_4002_1667",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(18.792 10.9738) rotate(180) scale(5.22784 9.248)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDCC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D6A195"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_4002_1667",
    x1: 21.1415,
    y1: 12.6593,
    x2: 16.7889,
    y2: 12.6593,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD6BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD6BA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint54_radial_4002_1667",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.5677 4.80298) rotate(90) scale(13.0253 10.7865)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.754072,
    stopColor: "#BC847A",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A36F64"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint55_radial_4002_1667",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(18.4315 9.66093) rotate(-90) scale(1.14835 1.42108)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.325,
    stopColor: "#F6B8A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6B8A8",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint56_radial_4002_1667",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.6841 9.70743) rotate(-89.7942) scale(1.09428 1.19084)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.377617,
    stopColor: "#D39991"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D39991",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint57_radial_4002_1667",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(19.4171 11.9618) rotate(176.388) scale(8.51288 21.7461)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.835902,
    stopColor: "#E6AD97",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6AD97"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint58_radial_4002_1667",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(10.5169 6.64852) rotate(-46.6112) scale(4.51041 1.65113)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.427646,
    stopColor: "#9F6D5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F6D5C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint59_radial_4002_1667",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(18.4114 5.99483) rotate(121.159) scale(3.36898 2.78136)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0780198,
    stopColor: "#F6C3B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6C3B0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_4002_1667",
    x1: 16.8224,
    y1: 11.6485,
    x2: 15.9842,
    y2: 11.6834,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.360477,
    stopColor: "#FFDFC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDFC7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint61_radial_4002_1667",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.4504 12.3343) rotate(90) scale(0.244102 0.767179)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDDC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDDC7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_4002_1667",
    x1: 15.9842,
    y1: 12.7877,
    x2: 15.9842,
    y2: 12.3227,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D89793"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D89793",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint63_radial_4002_1667",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.5667 11.7648) rotate(155.369) scale(1.67341 2.6893)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.714105,
    stopColor: "#D3968C",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3968C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_4002_1667",
    x1: 15.9842,
    y1: 9.95361,
    x2: 15.9842,
    y2: 10.6292,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8BBA8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8BBA8",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_4002_1667",
    x1: 14.7823,
    y1: 14.3587,
    x2: 15.1008,
    y2: 13.5242,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECBCAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ECBCAE",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint66_radial_4002_1667",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15.9841 14.5131) rotate(-90) scale(0.720735 2.8997)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#88014E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#86004D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint67_linear_4002_1667",
    x1: 22.8361,
    y1: 5.31111,
    x2: 11.2239,
    y2: 5.31111,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#443D40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#272127"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint68_radial_4002_1667",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(10.7545 8.08148) rotate(-90) scale(3.50132 8.85443)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.535851,
    stopColor: "#3E3433"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E3433",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint69_radial_4002_1667",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(20.8448 9.39176) rotate(-87.4012) scale(2.51513 4.45631)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F4D4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F4D4D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint70_radial_4002_1667",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(20.0906 3.11538) rotate(-146.667) scale(2.82328 2.07243)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E5A5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5E5A5B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint71_radial_4002_1667",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15.079 1.52306) rotate(58.4652) scale(1.73056 4.00716)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.286771,
    stopColor: "#484646"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#484646",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint72_radial_4002_1667",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.2377 3.78225) rotate(180) scale(2.20112 0.816923)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#423C3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423C3F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint73_radial_4002_1667",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(10.5535 7.72472) rotate(-57.7244) scale(6.02661 6.67686)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0926981,
    stopColor: "#0B0306"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.311222,
    stopColor: "#1C0C20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C0C20",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint74_radial_4002_1667",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(19.3983 4.55903) scale(3.05838 1.19577)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E494B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E494B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint75_radial_4002_1667",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(18.6179 7.59632) rotate(-43.6141) scale(3.69988 6.77353)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.856906,
    stopColor: "#545051",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#545051"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint76_radial_4002_1667",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(17.732 6.11986) rotate(6.66666) scale(3.27032 1.36922)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#200E25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#200E25",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint77_radial_4002_1667",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(18.1662 10.0576) rotate(90) scale(0.811318 1.29049)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.80198,
    stopColor: "#7D574A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#694B43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#804D49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#664842"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint78_radial_4002_1667",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(17.9379 10.1417) rotate(-127.812) scale(0.378287 0.52081)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.765532,
    stopColor: "#FFE6E2",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.966159,
    stopColor: "#FFE6E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint79_linear_4002_1667",
    x1: 18.9443,
    y1: 10.1115,
    x2: 18.6305,
    y2: 10.3048,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B4948D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B4948D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint80_radial_4002_1667",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.8021 10.0576) rotate(90) scale(0.81136 1.29056)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.80198,
    stopColor: "#7D574A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#694B43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#804D49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#664842"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint81_linear_4002_1667",
    x1: 14.546,
    y1: 10.1114,
    x2: 14.2322,
    y2: 10.3048,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B4948D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B4948D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint82_radial_4002_1667",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.5157 10.2767) rotate(-90.897) scale(0.494144 0.593981)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.765532,
    stopColor: "#FFE6E2",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.966159,
    stopColor: "#FFE6E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint83_linear_4002_1667",
    x1: 22.4206,
    y1: 10.1383,
    x2: 21.2137,
    y2: 12.3146,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD6BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0B8A6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint84_radial_4002_1667",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(20.602 10.0713) rotate(74.3475) scale(2.32966 2.22268)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.856273,
    stopColor: "#CE978E",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CE978E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint85_radial_4002_1667",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(20.9623 10.616) rotate(-53.9198) scale(1.33768 1.12124)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.663731,
    stopColor: "#F7B99C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7B99C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint86_radial_4002_1667",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(21.0763 10.7885) rotate(-69.2631) scale(1.65782 2.21508)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.803247,
    stopColor: "#EBBB9D",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBBB9D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint87_linear_4002_1667",
    x1: 10.1344,
    y1: 10.8424,
    x2: 11.5926,
    y2: 10.715,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D19787"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9887D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint88_radial_4002_1667",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.0686 10.715) rotate(-173.034) scale(1.62516 1.74453)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.77507,
    stopColor: "#E8AF99",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8AF99"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint89_radial_4002_1667",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.0698 10.7151) rotate(170.26) scale(0.929881 1.14101)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C18472"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CA8B7A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint90_linear_4002_1667",
    x1: 21.4631,
    y1: 9.76733,
    x2: 21.4631,
    y2: 11.6707,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9BB9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6BBA0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint91_linear_4002_1667",
    x1: 16.0797,
    y1: 8.9074,
    x2: 16.0797,
    y2: 12.6887,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#402857"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#251732"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint92_radial_4002_1667",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.375 10.0115) scale(0.90625 2.71875)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#52396B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#52396B",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeacher);
export default __webpack_public_path__ + "static/media/teacher.98beaabd2798271edbf7e3edb85afd14.svg";
export { ForwardRef as ReactComponent };